import { createContext } from 'react';
import defaultPropsDecorator from './defaultPropsDecorator';
export var PropsDecoratorContext = /*#__PURE__*/createContext(defaultPropsDecorator);
export default PropsDecoratorContext.Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/substyle/es6/PropsDecoratorProvider.js
// module id = 140
// module chunks = 0